import { oz } from '@weft/utils';

const documentationCodegen = typeof process !== 'undefined' && !!process.env['DOCUMENTATION_GEN'];

const AdvancedApiDateSchema = oz.union([
  oz.string().pipe(oz.coerce.date()),
  oz.date().openapi({ format: 'date-time' }),
]).openapi('ApiDate', { format: 'date-time' });

export const ApiDateSchema = documentationCodegen
  ? oz.date().openapi({ format: 'date-time' })
  : AdvancedApiDateSchema; 

export type ApiDate = oz.infer<typeof AdvancedApiDateSchema>;